import React, { useMemo } from "react";
import FacilitiesContainer from "./facilities_container";

export default function RoomFacilities({ facilities }) {
  const availableFacilities = useMemo(() => {
    if (!Array.isArray(facilities)) {
      return [];
    }

    return facilities.map((facilityGroup) => facilityGroup.facilities).flat();
  }, [facilities]);


  if (!availableFacilities.length) {
    return null;
  }
  return (
    <>
      <FacilitiesContainer facilities={availableFacilities} />
     
    </>
  );
}
